import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

export const SUPPORTED_LANGUAGES = {
  en: {localeName: 'English'},
  es: {localeName: 'Español - Spanish'},
  ar: {localeName: 'العربية - Arabic'},
};

// Get load path based on current nev
const getLoadPath = (env = process.env.RAILS_ENV) => {
  switch (env) {
    case 'test': // Use mock file iff in test env
      return '/locales/__mocks__/en.json';
    default: 
      // Add `DEPLOY_TIME` (set by Docker) to bust cached files on each deploy.
      // Development uses current time to cache bust on each reload.
      return `/locales/{{lng}}.json?v=${process.env.DEPLOY_TIME || Date.now()}`
  }
};

export const initI18nOptions = {
  fallbackLng: 'en',
  debug: false,
  whitelist: Object.keys(SUPPORTED_LANGUAGES),
  detection: {
    checkWhitelist: true,
  },
  backend: {
    loadPath: getLoadPath(),
  },
};

i18n.use(Backend).use(LanguageDetector).init(initI18nOptions);

export default i18n;
